import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params }   from '@angular/router';
import { Location }                 from '@angular/common';

import * as _ from 'lodash';

import 'rxjs/add/operator/switchMap';

import { UserService } from '../../services/users/user.service';



interface FileReaderEventTarget extends EventTarget {
    result:string
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage():string;
}



@Component({
  moduleId: module.id,
  selector: 'my-user-detail',
  template: ``
})


export class UserDetailComponent implements OnInit {
  //whToCheck:any;
  whChanged:boolean=false
  loadingImage:boolean=false;
  url:string;
  user: any;
  updatedUser: any;
  _: any;
  image: string;
  firmaCargada:boolean = false
  imagenCargada:boolean = false
  loading:boolean=true
  date:Date;
  changeAlert:boolean=false;
  saveAlert:boolean=false;
  noChangesAlert:boolean=false;
  alertUpload:boolean=false;
  closeAlertUpload(){
    this.alertUpload=false;
  }
  closeSaveAlert(){
    this.saveAlert=false;
  }
  closeChangeAlert(){
    this.changeAlert=false;
  }
  closeNoChangeAlert(){
    this.noChangesAlert=false;
  }
  protected getDefaultUserImageUrl(): string { return; };

  constructor(
    protected userService: UserService,
    protected route: ActivatedRoute,
    protected location: Location
  ) {}

  ngOnInit(): void {

    this._ = _;

    this.route.params
      .switchMap((params: Params) => this.userService.getOne(params['id'])
      //.then(() => this.loading=false)
      )
      .subscribe((user) => {

        this.user = user;
        this.updatedUser = _.clone(user);
        this.fillObject()
        this.loading=false
        this.putDate();
        this.getInfo();
        this.getFamily();
        this.getProviders()
      });
  }
  

  goBack(bool:boolean): void {
    let updatedFields: any = this.getUpdatedFields();
    if (!_.isEmpty(updatedFields) && bool != true) {      
     this.changeAlert=true;
    }    
    else this.confirmGoBack()
  }

  confirmGoBack(){
    this.location.back();
  }

  save(): void {
    
    let updatedFields: any = this.getUpdatedFields();

    if (_.isEmpty(updatedFields) && this.url==undefined) {
      this.noChangesAlert = true;
      return;
    }
    this.saveAlert=true;
  }
  saving():void{
    
    let updatedFields: any = this.getUpdatedFields();
    console.log(updatedFields)
    this.userService.update(this.user.id, updatedFields)
      .then(() => 
      this.location.back())
  }


  protected getUpdatedFields(): any {

    let updatedFields = {};
    let self = this;



    _.each(self.updatedUser, function (value: any, key: string) {

      if (key=='workingHours' && self.whChanged){
        updatedFields[key] = value;
      }
      if (self.user[key] !== value) {

        updatedFields[key] = value;
        console.log("adentro save")
      }

      
    });

    return updatedFields;
  }



readUrl(event) {
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();

    reader.onload = (event:FileReaderEvent) => {
      this.url = event.target.result;
    }

    reader.readAsDataURL(event.target.files[0]);
  }
}

  changeImage($ev:any){    
    
    var inputValue = $ev.target;    
    let file = inputValue.files[0];

   //let filesize = ((file.size/1024)/1024).toFixed(4); // MB

   this.loadingImage=true;

    var formData =new FormData();
    formData.append("image",  file);
    this.userService.updateImage(this.updatedUser.id,formData)//.then(()=>{window.location.reload()});
    .then(() =>
    {
      this.readUrl($ev);
      this.loadingImage=false;
      this.alertUpload=true;
    },function(e) {
      console.log('error!')
    })
  }

  fillObject(){

    return;
  }
  putDate(){
    return;
  }
  getInfo(){
    return;
  }
  getFamily(){
    return;
  }
  getProviders(){
    return;
  }

  activate(familyGroupId){
    this.userService.activate(this.updatedUser.id,familyGroupId).then(()=>{
      this.updatedUser["active"] = true
    })
  }
  deactivate(familyGroupId){
    this.userService.deactivate(this.updatedUser.id,familyGroupId).then(()=>{
      this.updatedUser["active"] = false
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/users/detail/user-detail.component.ts